import { useContext } from "react";
import { BraintreeContext } from "@/contexts/BraintreeProvider";

export function useBraintree() {
  const context = useContext(BraintreeContext);

  if (!context) {
    throw new Error("useBraintree must be used within a BraintreeProvider");
  }

  return context;
}
